module.exports = __webpack_public_path__ + "img/bg-section-01.cf9217cb.svg";